import paramsService from './params-service';
import apiService from './api-service';

function reLogin(res,args={}) {
  res=res.code?res:res.data;
  args.callback?args.callback.call(this,res):'';
}

function requestPromise(url,options){
	return new Promise((resolve,reject)=>{
		apiService[options.method](url,options.params,options.options).then(res=>{
			reLogin(res);
			var rawData=res;
			res=res.code?res:res.data;
			if(!res){
			  resolve(rawData);
			  return;
      };
			if(res.code==1){
				resolve(res.data);
			}else{
				reject(res);
			}
		}).catch(error=>{
		  reject(error);
    });
	});
}

export default {
  paramsService,
  apiService,
  requestPromise
};



// WEBPACK FOOTER //
// ./src/common/service/index.js